module.exports = __webpack_public_path__ + "img/avatar4.0ca5c9d3.png";